import { type PropsWithChildren } from 'react';
import {
  BackButton,
  NextButton,
  ScreenFields,
  useFormNav,
} from '@updater/ui-informant';
import { Box, Flex, H1, Text } from '@updater/ui-uds';

export interface AuthStackedTemplateProps {
  footerPanel?: React.ReactNode;
  backButton?: React.ReactNode;
  nextButton?: React.ReactNode;
}

export const AuthStackedTemplate: React.FC<
  PropsWithChildren<AuthStackedTemplateProps>
> = ({ footerPanel, backButton, nextButton }) => {
  const { currentScreenConfig, currentScreenIndex } = useFormNav();

  const showBackButton = !currentScreenConfig?.hideBackButton;
  const textAlign = currentScreenIndex === 0 ? 'center' : 'left';

  return (
    <Flex flexDirection="column" width="100%">
      {showBackButton && <Box mb="m">{backButton || <BackButton />}</Box>}
      <Box mb="m">
        {currentScreenConfig?.heading && (
          <H1
            as="h1"
            variant="xxlBold"
            textAlign={textAlign}
            style={{
              lineHeight: '40px',
              letterSpacing: '-0.64px',
              fontFeatureSettings: "'salt' on",
            }}
          >
            {currentScreenConfig.heading}
          </H1>
        )}
        {currentScreenConfig?.subHeading && (
          <Box mt="xs">
            <Text
              variant="l"
              color="textSoft"
              textAlign={textAlign}
              style={{
                whiteSpace: 'pre-line',
                fontFeatureSettings: "'salt' on",
              }}
            >
              {currentScreenConfig.subHeading}
            </Text>
          </Box>
        )}
      </Box>
      <Box mb="xl">
        <ScreenFields />
      </Box>
      <Box mb="xl">{nextButton || <NextButton />}</Box>
      {footerPanel ? <Box mb="xl">{footerPanel}</Box> : null}
    </Flex>
  );
};
